// extracted by mini-css-extract-plugin
module.exports = {"container":"PointPlanCompletion_container__4w94p","block":"PointPlanCompletion_block__2hrgd","triangle":"PointPlanCompletion_triangle__U84YZ"};